import { FormEvent } from 'react';
import i18n from '../R/string/i18n';
import InputForm from '../molecules/InputForm';
import ErrorBox from '../organisms/ErrorBox';
import { Button, ButtonContainer, FormWrapper } from '../atoms/EditFormContent';
import ButtonLabel from '../atoms/ButtonLabel';

interface Props {
  nickname: string;
  onChangeNickname: (e: React.ChangeEvent<HTMLInputElement>) => void;
  nicknameErr?: string;
  serverErrMsg?: string;
  updateEnabled: boolean;
  onUpdateNickname: (event: FormEvent<HTMLFormElement>) => void;
}

const UpdateNicknameForm = ({
  nickname,
  onChangeNickname,
  nicknameErr,
  serverErrMsg,
  updateEnabled,
  onUpdateNickname
}: Props) => (
  <>
    <ErrorBox message={serverErrMsg} />
    <FormWrapper onSubmit={onUpdateNickname}>
      <InputForm
        label={i18n.userInfoNickname()}
        type="text"
        value={nickname}
        onChange={onChangeNickname}
        errorMessage={nicknameErr}
        placeholder={i18n.userInfoNickname()}
      />
      <ButtonContainer>
        <Button type="submit" disabled={updateEnabled}>
          <ButtonLabel>{i18n.commonSave()}</ButtonLabel>
        </Button>
      </ButtonContainer>
    </FormWrapper>
  </>
);

export default UpdateNicknameForm;
